module.exports = __webpack_public_path__ + "img/6-reference-highlighted-banner.82da165c.webp";